module.exports = __webpack_public_path__ + "./assets/4-c7e82b.bmp";


//////////////////
// WEBPACK FOOTER
// ./assets/4.bmp
// module id = 22
// module chunks = 0